import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendInvite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.9456 3.21251C14.3324 3.09125 14.7557 3.06433 15.1777 3.15465C16.4595 3.42909 17.2591 4.67498 16.9635 5.93732L14.67 15.7329C14.3745 16.9953 13.0958 17.7963 11.814 17.5218C11.1737 17.3847 10.6531 17.0038 10.3304 16.5016L7.86784 12.664L3.76451 10.5728C2.60281 9.98097 2.16185 8.57058 2.77895 7.42243C3.06443 6.89125 3.55638 6.46271 4.185 6.26598L13.9456 3.21251ZM4.58327 7.53907C4.31365 7.6235 4.10369 7.80581 3.98067 8.03469C3.71614 8.52694 3.90538 9.13131 4.40306 9.38487L8.20578 11.3223L11.9433 7.33789C12.1995 7.06484 12.6303 7.04473 12.9052 7.29289C13.18 7.54112 13.1951 7.964 12.939 8.2371L9.20147 12.2215L11.4841 15.7783C11.6231 15.9948 11.8451 16.1566 12.1197 16.2155C12.669 16.3331 13.2169 15.99 13.3436 15.449L15.6371 5.65343C15.7638 5.11243 15.4213 4.5786 14.8719 4.46099C14.6904 4.42211 14.5101 4.43346 14.3445 4.4854L4.58327 7.53907Z",
		fill: "currentColor"
	})
});
export default SvgSendInvite;
